import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkle } from '@phosphor-icons/react';
import axios from 'axios';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function NewSinceLastCRCBadge({ chantierId, onClick }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!chantierId) return;

    const fetchCount = () => {
      axios
        .get(`${API_URL}/api/chantiers/${chantierId}/since-last-crc`, { withCredentials: true })
        .then((r) => setData(r.data))
        .catch(() => setData({ total: 0 }));
    };

    fetchCount();
    const interval = setInterval(fetchCount, 90_000);
    return () => clearInterval(interval);
  }, [chantierId]);

  if (!data || data.total === 0) return null;

  const { details, total } = data;
  const handleClick = onClick || (() => navigate(`/chantiers/${chantierId}?tab=suivi&action=create-crc`));

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={handleClick}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-orange-50 hover:bg-orange-100 text-orange-700 rounded-md text-sm font-medium transition-colors border border-orange-200"
            data-testid="new-since-last-crc-badge"
          >
            <Sparkle size={14} weight="fill" />
            {total} nouveau{total > 1 ? 'x' : ''} élément{total > 1 ? 's' : ''}
          </button>
        </TooltipTrigger>
        <TooltipContent className="text-xs max-w-xs" side="bottom">
          <div className="font-semibold mb-1.5">Depuis le dernier compte rendu :</div>
          {details?.messages > 0 && <div>• {details.messages} message{details.messages > 1 ? 's' : ''}</div>}
          {details?.reserves > 0 && <div>• {details.reserves} réserve{details.reserves > 1 ? 's' : ''}</div>}
          {details?.factures > 0 && <div>• {details.factures} facture{details.factures > 1 ? 's' : ''}</div>}
          {details?.taches_terminees > 0 && (
            <div>• {details.taches_terminees} action{details.taches_terminees > 1 ? 's' : ''} levée{details.taches_terminees > 1 ? 's' : ''}</div>
          )}
          {details?.points_crc_resolus > 0 && (
            <div>• {details.points_crc_resolus} point{details.points_crc_resolus > 1 ? 's' : ''} du CR résolu{details.points_crc_resolus > 1 ? 's' : ''}</div>
          )}
          <div className="text-orange-600 mt-2 font-medium">Cliquer pour rédiger le compte rendu</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
